exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{font-family:open_sansregular}.container{max-width:880px;padding:20px;margin:0 auto}h2{font-family:montserratmedium;font-size:2rem;color:#333;margin-top:50px;font-weight:400}p{line-height:1.9;color:#404040}ul{list-style:none;margin:30px 0 0}li,ul{padding:0}li{margin:0 0 20px}li strong{font-family:montserratmedium;font-weight:400}li p{margin:0}a{color:#97c11f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64f297e5","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 9
// module chunks = 0